export const useBlogMentions = (content: string) => {
  const regex = /href=["'](.*?)["']/g;
  const matches = content.match(regex);

  const links = matches?.map((match) => {
    const href = /href=["'](.*?)["']/.exec(match);
    return href ? href[1] : '';
  }).filter((link) => link.includes('www.klaviyo.com/'));

  return links;
};
